import { combineReducers } from "redux";
import LoginReducers from "./LoginReducers";
import { RegisterReducers } from "./RegisterReducers";
import SacReducers from "./SacReducers";
import CouponReducers from "./CouponReducers";
import RegisterPayUReducers from "./RegisterPayUReducers";
import { CampaignReducer } from "./CampaignReducer";

const RootReducer = combineReducers({
  auth: LoginReducers,
  register: RegisterReducers,
  sac: SacReducers,
  payu: RegisterPayUReducers,
  coupon: CouponReducers,
  campaign: CampaignReducer,
});

export default RootReducer;
